<template>
  <article
    :id="`service-${id}`"
    class="service-widget" 
    @click="openService($event)">

      <ServiceOrigami
        :animal="origami"
        :type="'service'" />
        
    <aside 
      :class="{'in-detail': step}"
      v-html="hasNav ? (hasNext ? '&#8594;' : '&#8592;') : ''"></aside>

    <h3 v-html="name"></h3>
    <p v-html="excerpt"></p>
  </article>
</template>

<script>

import ServiceOrigami from '../origami/ServicesOrigami.vue'

export default {
  name: 'service-widget',
  props: ['hasNav','hasNext','step','slug', 'name', 'excerpt', 'origami', 'single', 'id'],
  components: {
    ServiceOrigami
  },
  mounted() {
    // debugger
    
  },
  computed: {
    isSingle: function() {
      return this.single === true;
    }
  },
  methods: {
    openService:  function(t) {
      this.$emit('openService', t.currentTarget, this.slug)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../styles/_mixins.scss';

  article {
    position: relative;
    cursor: pointer;
    background: white;
    padding-bottom: $large_vmin;
    margin-top: 5vmin;

    @include respond-to(tablet) {
      margin-top: 0;
      @include grid(12);
      padding-bottom: 0;
      grid-column-gap: 0;
      grid-template-rows: 25vw 35vmax;
    }

    @include respond-to(desktop) {
      // grid-template-rows: 50vh 50vh;
      grid-template-rows: 25vw 25vw;
    }

    &.ia  {
      aside {
      background: map-get($colors--palette, 'secondary');
      }
     }

    figure {
      position: relative;
      @include bgImage(cover);
      @include ratio(5,3);

      @include respond-to(tablet) {
      @include ratio(1,1);
        grid-column: 7 / span 6;
        grid-row: 1 / span 2;
      }
    }

    h3,
    p {
      margin-top: $default_vmin;
      @include grid-padding;

      @include respond-to(tablet) {
        grid-column: 2 / span 4;
        margin: 0;
        padding: 0;
      }
    }

    h3 {
      margin-top: $default_vmin*4;

      @include respond-to(tablet) {
        grid-row-start: 1;
        align-self: end;
      }
    }

    p {
      margin-bottom: $default_vmin;
      position: relative;

      @include respond-to(tablet) {
        margin-top: 4.375rem;
        font-size: 1.375rem;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 1.2rem;
          height: 4px;
          background: #25BCCA;
        }
      }
    }

    aside {
      position: absolute;
      width: $big_vmin;
      height: $big_vmin;
      left: 0;
      top: 50%;
      transform: translate(0, -100%);
      z-index: 25;
      font-size: 3vmax;
      @include center-content(column);
      text-decoration: underline;
      font-weight: 700;
      background: map-get($colors--palette, 'secondary');
      color: map-get($colors--grays , '3' );

      @include respond-to(tablet) {
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
        width: $large_vmin;
        height: $large_vmin;
      }

      @include respond-to(desktop) {
        width: $big_vmin;
        height: $big_vmin;
      }

      &:not(.in-detail) {
        font-size: 1rem;
        &:before {
          counter-increment: service;                   /* Increment the value of service counter by 1 */
          content: "0" counter(service);    /* Display the word 'service ', the value of service counter, and a colon before the content of each a tag */
          transition: all 1s;
        }
      }
    }
    
    &:nth-of-type(even) {
      figure {
        grid-column: 1 / span 6;
      }

      h3,
      p {
        grid-column: 8 / span 4;
      }
      aside {
        @include respond-to(tablet) {
          left: auto;
          right: 50%;
          transform: translate(50%, -50%);
        }
      }
    }
  }


  figure {
    .ia & {
      background-color: #1A9DAE;
    }
    .iceberg & {
      background-color: #f8c81c;
    }
    .front & {
      background-color: #ffaa15;
    }

    .ux & {
      background-color: #ffaa15;
    }

    .banner & {
      background-color: orange;
    }
    .legal & {
      background-color: #bf4228;
    }
  }
</style>